import type { Perimeter } from '@atlassian/atl-context';

import { CategoryStorageType } from '../../../types';

export const LEGACY_COOKIE_CACHE_URL_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';

export const COOKIE_CACHE_URL_COMMERCIAL_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';

export const LOCAL_STORAGE_CACHE_URL_COMMERCIAL_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';

export const SESSION_STORAGE_CACHE_URL_COMMERCIAL_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';

export const INDEXED_DB_CACHE_URL_COMMERCIAL_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_INDEXED_DB.json';

export const COOKIE_CACHE_URL_FEDRAMP_MODERATE_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_COOKIE.json';

export const LOCAL_STORAGE_CACHE_URL_FEDRAMP_MODERATE_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_LOCAL_STORAGE.json';

export const SESSION_STORAGE_CACHE_URL_FEDRAMP_MODERATE_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_SESSION_STORAGE.json';

export const INDEXED_DB_CACHE_URL_FEDRAMP_MODERATE_PROD =
	'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_INDEXED_DB.json';

export const COMMERCIAL_CATEGORY_CACHE_URL_LOOKUP: Record<CategoryStorageType, string> = {
	[CategoryStorageType.Cookies]: COOKIE_CACHE_URL_COMMERCIAL_PROD,
	[CategoryStorageType.LocalStorage]: LOCAL_STORAGE_CACHE_URL_COMMERCIAL_PROD,
	[CategoryStorageType.SessionStorage]: SESSION_STORAGE_CACHE_URL_COMMERCIAL_PROD,
	[CategoryStorageType.IndexedDB]: INDEXED_DB_CACHE_URL_COMMERCIAL_PROD,
};
export const CATEGORY_CACHE_URL_PERIMETER_LOOKUP: Partial<
	Record<Perimeter, Record<CategoryStorageType, string>>
> = {
	commercial: COMMERCIAL_CATEGORY_CACHE_URL_LOOKUP,
	'fedramp-moderate': {
		[CategoryStorageType.Cookies]: COOKIE_CACHE_URL_FEDRAMP_MODERATE_PROD,
		[CategoryStorageType.LocalStorage]: LOCAL_STORAGE_CACHE_URL_FEDRAMP_MODERATE_PROD,
		[CategoryStorageType.SessionStorage]: SESSION_STORAGE_CACHE_URL_FEDRAMP_MODERATE_PROD,
		[CategoryStorageType.IndexedDB]: INDEXED_DB_CACHE_URL_FEDRAMP_MODERATE_PROD,
	},
};
